module.exports = __webpack_public_path__ + "img/99.3e5cd254.jpg";